import { useEffect, useState } from "react";
import { OrganizersAPI } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { toast } from "sonner";
import { UserCog } from "lucide-react";

export default function OrganizerAssignCard({ organizerId, onAssign }) {
  const { user } = useAuth();
  const [organizers, setOrganizers] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user?.role === "admin") {
      OrganizersAPI.list().then(setOrganizers).catch(() => {});
    }
  }, [user?.role]);

  if (user?.role !== "admin") return null;

  const change = async (v) => {
    setBusy(true);
    try {
      await onAssign(v === "none" ? null : v);
      toast.success(
        v === "none"
          ? "Page reprise par l'admin"
          : "Organisateur assigné — il peut maintenant gérer cette page",
      );
    } catch {
      toast.error("Échec de l'assignation");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="bg-[#111216] border border-white/10 rounded-xl p-5 md:p-6 mb-10"
      data-testid="organizer-assign-card"
    >
      <div className="flex items-center gap-2 mb-1">
        <UserCog className="w-4 h-4 text-[#D4AF37]" />
        <h3 className="font-display text-lg font-bold uppercase tracking-tight">
          Organisateur assigné
        </h3>
      </div>
      <p className="text-zinc-500 text-xs font-body mb-4">
        Donne la gestion de cette page à un compte organisateur : il la verra
        dans son tableau de bord et pourra la modifier.
      </p>
      <Select
        value={organizerId || "none"}
        onValueChange={change}
        disabled={busy}
      >
        <SelectTrigger
          className="bg-white/[0.04] border-white/10 text-white h-10"
          data-testid="organizer-assign-select"
        >
          <SelectValue placeholder="Aucun organisateur" />
        </SelectTrigger>
        <SelectContent className="bg-[#111216] border-white/10 text-white">
          <SelectItem value="none">Aucun (géré par l'admin)</SelectItem>
          {organizers.map((o) => (
            <SelectItem key={o.id} value={o.id} data-testid={`organizer-option-${o.email}`}>
              {o.name || o.email} ({o.email})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
